export default __webpack_public_path__ + "static/media/330_dummy2016-kunstgalerie01-de.bacc9f7a.png";